import {AfterViewInit, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {IFormItems} from '../../../../../interface/form-structure';
import {IViewComponent} from '../../../../../interface/panels';
import {NoosFormTypeService} from '../../../../../class/NoosFormTypeService';

@Component({
    selector: 'noos-dashboard-container-masterlist',
    templateUrl: './dashboard-container-masterlist.component.html',
    styleUrls: ['./dashboard-container-masterlist.component.scss']
})

@NoosFormTypeService.register('ViewDASHBOARDmasterlist')
export class DashboardContainerMasterlistComponent implements OnInit, IViewComponent, AfterViewInit {

    formJson: IFormItems[];
    isFilter: boolean;

    @Output()
    keyOnEnter = new EventEmitter<any>();

    @Input()
    datasetId = 0;

    @Input()
    formId = 0;

    constructor() {
    }

    ngOnInit() {
    }

    ngAfterViewInit(): void {
    }


    onEnterEvent($event: any) {
        this.keyOnEnter.emit();
    }

}
